/**
 * Общие константы списков разговоров (сессии + звонки).
 *
 * Высоты строк дублируются в CSS (`.list-row { height }`) — cdk-virtual-scroll
 * с `itemSize` требует, чтобы значения совпадали ровно, иначе виртуальный
 * скроллер промахивается мимо позиции при прокрутке.
 */
export const DESKTOP_ROW_HEIGHT = 56;
export const MOBILE_ROW_HEIGHT = 68;

/** За сколько строк до конца загруженных данных запрашивать следующую страницу. */
export const LOAD_MORE_THRESHOLD = 8;
